import PropTypes from 'prop-types';
import { m } from 'framer-motion';
import { useRef } from 'react';
// @mui
import { useTheme, alpha } from '@mui/material/styles';
import { Box, Stack, Card, Button, Container, Typography, IconButton, Grid } from '@mui/material';
// components
import Image from '../../../components/minimal/image';
import Carousel, { CarouselArrows } from '../../../components/minimal/carousel';
import { MotionViewport, varFade } from '../../../components/minimal/animate';

// ----------------------------------------------------------------------
  
const _carouselsMembers = [
    {
        id: 1,
        name: "מופעי תרבות",
        role: "בתי תרבות ומארגני ארועים",
        avatar: `/assets/images/home/culture.jpg`,
    },
    {
        id: 2,
        name: "ארועי ספורט",
        role: " מועדוני ספורט ואצטדיונים",
        avatar: `/assets/images/home/sports.jpeg`,
    },
    {
        id: 3,
        name: "מסיבות",
        role: " מועדני לילה ודיג'ים ",
        avatar: `/assets/images/home/club.webp`,
    },
    {
        id: 4,
        name: "סדנאות וכנסים",
        role: "מרצים",
        avatar: `/assets/images/home/workshops.jpg`,
    },
];

export default function ActivitySection() {

  return (
    <Container component={MotionViewport} sx={{ textAlign: 'center', mt: 16 }}>
      <m.div variants={varFade().inDown}>
        <Typography component="p" variant="overline" sx={{ color: 'text.disabled' }}>
          {/* תחומי פעילות */}
        </Typography>
      </m.div>

      <m.div variants={varFade().inUp}>
        <Typography variant="h2" sx={{ my: 3 }}>
          נימי יודעת להתאים את עצמה לתחום שלכם
        </Typography>
      </m.div>

      <m.div variants={varFade().inUp}>
        <Typography
          sx={{
            mx: 'auto',
            maxWidth: 640,
            color: 'text.secondary',
            mb: { xs: 5, md: 10 },
          }}
        >
         המערכת שלנו יודעת לשרת לקוחות בענפי פעילות שונים ומגוונים, יש לנו סט של כלים ופתרונות לכל סוגי האירועים
        </Typography>
      </m.div>

      <Grid container columns={{ sm: 2, md: 4 }} sx={{gap: 4, justifyContent: 'center', alignItems: 'stretch'}}>

            {_carouselsMembers.map((member) => (
              <Box
                key={member.id}
                component={m.div}
                variants={varFade().in}
                sx={{ width: '100%', maxWidth: 250, height: '100%' }}   
              >
                <MemberCard member={member} />
              </Box>
            ))}

      </Grid>
    </Container>
  );
}

// ----------------------------------------------------------------------

MemberCard.propTypes = {
  member: PropTypes.shape({
    avatar: PropTypes.string,
    name: PropTypes.string,
    role: PropTypes.string,
  }),
};

function MemberCard({ member }) {
  const { name, role, avatar } = member;

  return (
    <Card key={name}>
      <Typography variant="subtitle1" sx={{ mt: 2, mb: 0.5 }}>
        {name}
      </Typography>

      <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
        {role}
      </Typography>

      <Box sx={{ px: 1 }}>
        <Image alt={name} src={avatar} ratio="1/1" sx={{ borderRadius: 2 }} />
      </Box>

      <Stack direction="row" alignItems="center" justifyContent="center" sx={{ p: 2 }}>
      </Stack>
    </Card>
  );
}
